import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query BillingZuoraCurrentPlan($businessId: ID!) {
    billingZuoraCurrentPlan(businessId: $businessId) {
      seats
      addOns {
        id
        name
      }
      startDate
      endDate
      cancelling
      paused
      renewalPending
      window
    }
  }
`

export const billingCurrentPlanKey = getQueryNames(query)[0]

export default query
